'use strict';

import * as Blockly from 'blockly/core';

Blockly.HSV_SATURATION = 0.6
Blockly.HSV_VALUE = 0.7

Blockly.Blocks['grove_button'] = {
  init: function() {
    this.jsonInit({
      "type": "grove_button",
      "message0": "Create Grove Button connected to pin %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["8", "8"], 
            ["16", "16"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_button_is_pressed'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "grove_button_is_pressed",
        "message0": "is Grove Button %1 pressed",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_joystick'] = {
  init: function() {
    this.jsonInit({
      "type": "grove_joystick",
      "message0": "Create Grove Joystick connected to pin %1 and pin %2",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin1",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["8", "8"], 
            ["16", "16"]
          ]
        },
        {
          "type": "field_dropdown",
          "name": "pin2",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["8", "8"], 
            ["16", "16"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};


Blockly.Blocks['grove_joystick_get_x'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "grove_joystick_get_x",
        "message0": "Grove Joystick %1 get ← → direction",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_joystick_get_y'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "grove_joystick_get_y",
        "message0": "Grove Joystick %1 get ↑ ↓ direction",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_minimotor'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove MiniMotor connected to motor output %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "motornum",
          "options": [
            ["0", "0"], 
            ["1", "1"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_minimotor_get_address'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "Grove MiniMotor %1 get address",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_minimotor_get_fault'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "Grove MiniMotor %1 get fault",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_minimotor_clear_fault'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "Grove MiniMotor %1 clear fault",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "previousStatement": null,
        "nextStatement": null,
        "colour": 360,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_minimotor_stop'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "Grove MiniMotor %1 slow down to a stop",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "previousStatement": null,
        "nextStatement": null,
        "colour": 360,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_minimotor_brake'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "Grove MiniMotor %1 brake sharply 🛑",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "previousStatement": null,
        "nextStatement": null,
        "colour": 360,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_minimotor_set_speed'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "grove_minimotor_set_speed",
        "message0": "Grove MiniMotor %1 set speed to %2",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          },
          {
            "type": "field_number",
            "name": "speed",
            "value": 0,
            "min": -255,
            "max": 255
          }
        ],
        "inputsInline": true,
        "previousStatement": null,
        "nextStatement": null,
        "colour": 360,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_moisture'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove Moisture connected to pin %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin1",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_moisture_get'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get moisture value from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_servo'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Servo connected to pin %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin1",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["8", "8"], 
            ["16", "16"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_servo_set'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "grove_servo_set",
        "message0": "Set servo %1 angle to %2",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          },
          {
            "type": "field_number",
            "name": "angle",
            "value": 0,
            "max": 360
          }
        ],
        "inputsInline": true,
        "previousStatement": null,
        "nextStatement": null,
        "colour": 360,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_sound'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove Sound connected to pin %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin1",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["3", "3"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_sound_get'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get volume from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_sunlight'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove Sunlight Sensor",
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_sunlight_get_uv'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get UV reading from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_sunlight_get_ir'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get IR reading from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_sunlight_get_visible'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get visible light reading from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_ultrasonic'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove Ultrasonic ranger connected to pin %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin1",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["8", "8"], 
            ["16", "16"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_ultrasonic_get'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get proximity value from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_vibration'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove Vibration motor connected to pin %1",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "pin1",
          "options": [
            ["0", "0"], 
            ["1", "1"], 
            ["2", "2"], 
            ["8", "8"], 
            ["16", "16"]
          ]
        }
      ],
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_vibration_set'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "grove_vibration_set",
        "message0": "Set Grove Vibration Motor %1 to %2",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          },
          {
            "type": "field_dropdown",
            "name": "val",
            "options": [
              [
                "On",
                "True"
              ],
              [
                "Off",
                "False"
              ]
            ]
          }
        ],
        "inputsInline": true,
        "previousStatement": null,
        "nextStatement": null,
        "colour": 360,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_weather'] = {
  init: function() {
    this.jsonInit({
      "type": "block_type",
      "message0": "Create Grove Weather object",
      "output": null,
      "colour": 200,
      "tooltip": "",
      "helpUrl": ""
    });
  }
};

Blockly.Blocks['grove_weather_get_temperature'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get Temperature reading from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_weather_get_pressure'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get Pressure reading from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};

Blockly.Blocks['grove_weather_get_humidity'] = {
  init: function() {
    this.jsonInit(
      {
        "type": "block_type",
        "message0": "get Humidity reading from %1",
        "args0": [
          {
            "type": "field_variable",
            "name": "grove_var",
            "variable": "item"
          }
        ],
        "inputsInline": true,
        "output": null,
        "colour": 135,
        "tooltip": "",
        "helpUrl": ""
      }
    );
  }
};